import { jsPDF } from "jspdf";

const loadImage = (src) => new Promise((resolve, reject) => {
  const img = new Image();
  img.onload = () => resolve(img);
  img.onerror = reject;
  img.src = src;
});

// pages: [{ scan, color, mode }] → File (application/pdf), each page sized to its scan at letter width.
export async function pagesToPdf(pages, filename) {
  let pdf = null;
  for (const p of pages) {
    const src = p.mode === "color" ? p.color : p.scan;
    const img = await loadImage(src);
    const w = 612;
    const h = Math.round((612 * img.height) / img.width);
    const orientation = w > h ? "l" : "p";
    if (!pdf) pdf = new jsPDF({ unit: "pt", format: [w, h], orientation, compress: true });
    else pdf.addPage([w, h], orientation);
    pdf.addImage(src, "JPEG", 0, 0, w, h, undefined, "FAST");
  }
  return new File([pdf.output("blob")], filename, { type: "application/pdf" });
}
